type IndianFormatOptions = {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

export const formatIndianNumber = (
  value: number | string | null | undefined,
  options?: IndianFormatOptions,
) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return String(value);
  }

  return numericValue.toLocaleString("en-IN", options);
};

export const formatIndianInteger = (value: number | string | null | undefined) =>
  formatIndianNumber(value, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

export const formatIndianAmount = (value: number | string | null | undefined) =>
  formatIndianNumber(value, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
